export const PendenciasWizard = {
  convenio: 'Convênio',
  atendimentoInternacao: 'Atendimento/Internação',
  profissionalResponsavel: 'Profissional Responsável',
  centroCirurgico: 'Centro cirúrgico',
  procedimentoPrincipal: 'Procedimento principal',
};

export function setPendencia(step, pendencia) {
  let pendenciasPaciente = JSON.parse(localStorage.getItem('pendenciasPaciente'));
  let pendenciasSolicitacao = JSON.parse(localStorage.getItem('pendenciasSolicitacao'));
  let pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));
  if (step === 0) {
    pendenciasPaciente = pendenciasPaciente.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasPaciente', JSON.stringify(pendenciasPaciente));
  }
  if (step === 1) {
    pendenciasSolicitacao = pendenciasSolicitacao.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasSolicitacao', JSON.stringify(pendenciasSolicitacao));
  }
  if (step === 2) {
    pendenciasCirurgia = pendenciasCirurgia.filter(e => e !== pendencia);
    localStorage.setItem('pendenciasCirurgia', JSON.stringify(pendenciasCirurgia));
  }
}

export function iniciaPilhaPendencias() {
  localStorage.setItem(
    'pendenciasPaciente',
    JSON.stringify([PendenciasWizard.convenio, PendenciasWizard.atendimentoInternacao])
  );
  localStorage.setItem(
    'pendenciasSolicitacao',
    JSON.stringify([PendenciasWizard.profissionalResponsavel, PendenciasWizard.centroCirurgico])
  );
  localStorage.setItem(
    'pendenciasCirurgia',
    JSON.stringify([PendenciasWizard.procedimentoPrincipal])
  );
}

export function getConfiguracoes() {
  const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

  if (configuracoes.convenioPadrao) {
    localStorage.convenio = JSON.stringify({
      id: configuracoes.convenioPadrao,
      descricao: configuracoes.convenioPadraoNome,
    });
    setPendencia(0, PendenciasWizard.convenio);
  }
  const profissional = JSON.parse(localStorage.getItem('profissional'));

  localStorage.equipeRequisitante = JSON.stringify({
    id: profissional.equipe_id,
    descricao: profissional.equipe,
  });
}
